/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelReportScheduleList.ts            *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "common/report-schedule-list";

export class AutogenModelReportScheduleList<RowType extends ModelRow> extends Endpoint<RowType, RowReportScheduleListFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowReportScheduleList extends ModelRow<RowReportScheduleListFields> {
	constructor(values?: Partial<RowReportScheduleListFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowReportScheduleListFields {
	beginning_time: Date;
	company_id: string;
	create_empty_rpt: string;
	descr: string;
	effective_from: Date;
	effective_to: Date;
	email_profile_id: string;
	ending_time: Date;
	id: string;
	indiv_user_report: string;
	is_active: string;
	is_temporary: string;
	month_day: string;
	month_frequency: string;
	monthly_date: number;
	next_generate_date: Date;
	notify_by_email: string;
	notify_by_rap_alrt: string;
	notify_email_addrs: string;
	notify_email_subject: string;
	notify_groups: string;
	notify_users: string;
	recurring_date: string;
	recurring_time: number;
	reply_to_address: string;
	report_class: string;
	run_friday: string;
	run_monday: string;
	run_saturday: string;
	run_sunday: string;
	run_thursday: string;
	run_tuesday: string;
	run_wednesday: string;
}

